module.exports = __webpack_public_path__ + "img/empilhadeiras_pag4_SMALL.c6333878.jpeg";